import React, { useState } from "react";
import DSSTextInput from "../../../../../ui/building-blocks/atoms/dss-textinput";
import DSSButton from "../../../../../ui/building-blocks/atoms/dss-button";
import { useDssContext } from "../../../../../DSSContext";
import AssociationSuccessModal from "./associate-success-modal";
import DSSModal from "../../../../../ui/building-blocks/atoms/dss-modal";
import { HoneywellAssociationData } from "../../model/model";
import "./index.scss";
import { associateHoneywellIdData, customerUsersSearch, getCustomerBasicInfoData, validateRoleData } from "../api/api";
import { notifyError } from "../../../../../ui/dls/dls-snackbar/dls-snackbar";
import DSSLoader from "../../../../../ui/building-blocks/atoms/dss-loader/dss-loader";
import { INDS_StoreFrontId } from "../../../../user-care/constant/constant";
import { INDS_CUSTOMER } from "../../../../../util/roles";
import { CREATE_ACCOUNT_URL } from "../../../../../interceptors/constant";
import { ActiveStatus, ExternalUserType, INDS_StoreFrontName, InternalUserType, Phone_Number } from "../../../../user-care/constant/operator-admin-contant";

interface Props {
  data: HoneywellAssociationData;
  accessToken?: string;
  onBack?: () => void;
  onSupport?: () => void;
  onClose: () => void;
}

const AssociateHoneywellStep: React.FC<Props> = ({
  data,
  onBack,
  onSupport,
  onClose,
  accessToken,
}) => {
 
  const { translate } = useDssContext();
  const [honeywellId, setHoneywellId] = useState("");
  const [honeywellIdError, setHoneywellIdError] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const isEmail = (value: string) => /\S+@\S+\.\S+/.test(value);

  const handleAssociate = async () => {
    let valid = true;
    setHoneywellIdError("");
    if (!honeywellId.trim()) {
      setHoneywellIdError("Honeywell ID is required");
      valid = false;
    }
    if (!valid) return;

    try {
      setLoading(true);

      const enteredValue = honeywellId.trim();
      const searchResponse = await customerUsersSearch({
        honeywellOrEmailId: enteredValue,
      }, accessToken || "");

      const resolvedHoneywellId = searchResponse?.honeywellid?.trim?.() || enteredValue;

      if (isEmail(enteredValue) && !resolvedHoneywellId) {
          notifyError("Honeywell ID not found for the provided email");
          return;
      }

      const customerBasicInfo = await getCustomerBasicInfoData({
        customerNumber: Number(data.scustNumber) || 0,
      }, accessToken || "");

      const resolvedCustomerId = Number(customerBasicInfo?.customerId ?? 0);
      const resolvedCompanyName = customerBasicInfo?.customerName || data.companyName || "";
     

      const firstName = searchResponse?.firstname?.trim?.() || "";
      const lastName = searchResponse?.lastname?.trim?.() || "";
      const emailId = searchResponse?.email?.trim?.() || "";

   

      await validateRoleData({
        honeywellId: resolvedHoneywellId,
        roleId: INDS_CUSTOMER,
        storeFrontId: INDS_StoreFrontId,
        customerId: resolvedCustomerId,
        companyName: resolvedCompanyName,
      }, accessToken || "");
      
   const now = new Date();
      const oneYearLater = new Date(now);
      oneYearLater.setFullYear(now.getFullYear() + 2);
      const payload = {
        honeywellId: resolvedHoneywellId,
        customerNumber: String(data.scustNumber),
        firstName,
        lastName,
        status: ActiveStatus,
        emailId,
        countryCode: "+00",
        phoneNumber: Phone_Number,
        userType: ExternalUserType,
        accessStartDate: now.toISOString(),
        accessEndDate: oneYearLater.toISOString(),
        customerRole: [{
          roleId: INDS_CUSTOMER,
        }],
        storeFrontId: INDS_StoreFrontId,
        storeFront: INDS_StoreFrontName,
      };
      await associateHoneywellIdData(payload, accessToken || "");
      setShowSuccess(true)
    } catch (e: any) {
      notifyError(e);
    } finally {
      setLoading(false);
    }
  };
  const handleCreateNow = () => {
        window.open(CREATE_ACCOUNT_URL, "_blank", "noopener,noreferrer");

  };

  return (
    <div>
      <div className="associate-details">
        {loading && <DSSLoader id="associate-loader" />}
        <div className="associate-auth-info">{translate('yourDetailsAsPerOurRecords')}</div>
        <div className="associate-row">
          <span>{translate('customerNo')} </span>
          <span className="associate-value">{data.scustNumber}</span>
        </div>
        <div className="associate-row">
          <span>{translate('companyName')} </span>
          <span className="associate-value">{data.companyName}</span>
        </div>
      </div>
      <div>
        <div className="associate-auth-info">{translate('pleaseEnterYourHoneywellId')}</div>
        <div className="create-honewell-row">
          <div className="create-honewell-input-col">
            <DSSTextInput
              id="associate-honeywell-id"
              label="Honeywell Aerospace ID"
              value={honeywellId}
              onChange={e => setHoneywellId(e.target.value)}
              className={honeywellIdError ? 'create-honeywell-input-error' : 'create-honeywell-input'}
            />
            {honeywellIdError && <div className="create-honeywell-error">{honeywellIdError}</div>}
          </div>
        </div>
        <div className="associate-auth-info">
          {translate('ifYouDoNotHaveHoneywellId')}
          <DSSButton
            variant="tertiary"
            type="button"
            onClick={handleCreateNow}
            id="associate-create-now-btn"
          >
            {translate('createNow')}
          </DSSButton>
        </div>
      </div>
      <div className="create-honeywell-divider" />
      <div className="create-honeywell-modal-actions-row">
        <div className="create-honeywell-support-info">
          {translate('ifYouAreFacingAnyIssues')}
         <DSSButton
            variant="secondary"
            className="create-honeywell-support-link"
            type="button"
            onClick={onSupport}
            id="associate-support-link"
          >
            {translate('here')}
          </DSSButton>.
        </div>
        <div className="create-honeywell-modal-actions">
          <DSSButton variant="secondary" type="button" onClick={onBack} id="associate-back-btn">
            {translate('back')}
          </DSSButton>
          <DSSButton
            variant="primary"
            type="button"
            style={{ marginLeft: 12 }}
            onClick={handleAssociate}
            id="associate-submit-btn"
            disabled={loading}
          >
            {loading ? translate('processing') : translate('associate')}
          </DSSButton>
        </div>
      </div>
      <DSSModal
        id="association-success-modal"
        isOpen={showSuccess}
        isShowClose={false}
        onClose={() => {
          setShowSuccess(false);
          onClose();
        }}
      >
        <AssociationSuccessModal
          onClose={() => {
            setShowSuccess(false);
            onClose();
          }}
        />
      </DSSModal>
    </div>
  );
};

export default AssociateHoneywellStep;